class ScrollLock {
    isBodyScrollable = false;

    setBodyScrollable(isScrollable: boolean) {
        this.isBodyScrollable = isScrollable;
    }
}

export default ScrollLock;
